module.exports = __webpack_public_path__ + "img/Attendance.c6bb5d71.png";